

















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Card, Button } from '@alpha/ink'
import { Test, Project, TestStatus } from '@shared/types/database'
import { User } from '@/types/frontend'
import { isCompleted } from '@/utilities/test-helpers'
import Followers from '@/components/TestDetails/Followers.vue'
import FollowerData from '@/views/TestDetails.vue'
import AssociatedProjects from '@/components/TestDetails/AssociatedProjects.vue'
import { EditProjectPayload } from '@/components/TestDetails/EditProjects.vue'

import Tags from './Tags.vue'
import { VUE_APP_LEGACY_API } from '@/config'

@Component({
  components: { Card, Followers, Button, Tags, AssociatedProjects }
})

export default class TestMetaData extends Vue {
  @Prop({ required: true }) readonly followers!: User[]
  @Prop({ required: true }) readonly users!: User[]
  @Prop({ required: true }) readonly test!: Test
  @Prop({ default: null }) readonly projects!: Project[] | null
  @Prop({ default: false }) readonly tagsUpdating!: boolean
  @Prop({ default: false }) readonly respondentCount!: number

  get completed () {
    return isCompleted(this.test.payload.status)
  }

  get tags (): string[] {
    if (!this.test.payload.tags) return []

    return this.test.payload.tags.split(',')
  }

  get isAdmin () {
    return this.$store.state.user.authenticatedUser.admin
  }

  get showRespondentCount () {
    return this.test.payload.status === TestStatus.Complete || (this.test.payload.status === TestStatus.InProgress && this.isAdmin)
  }

  get testAdminURL () {
    const workspaceId = this.$router.currentRoute.params.workspaceId
    const mgtLink = VUE_APP_LEGACY_API
    return `${mgtLink}/${workspaceId}/${this.test.id}/update`
  }

  editFollower (data: FollowerData) {
    this.$emit('editFollower', data)
  }

  editProject (data: EditProjectPayload) {
    this.$emit('edit-project', data)
  }
}

